import React from 'react';
import { Divider, Skeleton, SkeletonImage, Space } from '@ag1/ui';
import styles from './SubscriptionMainCardSkeleton.module.scss';

export const SubscriptionMainCardSkeletonMobile = () => (
  <Space top={16} bottom={16} className={styles.containerMobile}>
    <Space top={8} bottom={8} className={styles.rowBetween}>
      <Skeleton width={215} height={24} />
      <Skeleton width={60} height={24} />
    </Space>
    <Skeleton height={28} />
    <Space top={16} bottom={8}>
      <Skeleton width={215} height={44} />
    </Space>
    <Space top={4} bottom={4}>
      <Skeleton width={215} height={24} />
    </Space>
    <Divider top={16} bottom={16} />
    <Space top={8} bottom={8} className={styles.row}>
      <SkeletonImage width={112} aspectRatio={1.3333} className={styles.image} />
      <Space left={24} top={8} bottom={8} className={styles.fw}>
        <Skeleton height={24} />
        <Space top={8} className={styles.rowBetween}>
          <Skeleton width={79} height={20} />
          <Skeleton width={64} height={20} />
        </Space>
      </Space>
    </Space>
    <Divider top={16} bottom={16} />
    <Space top={4} bottom={4} className={styles.rowBetween}>
      <Skeleton width={164} height={24} />
      <Skeleton width={64} height={24} />
    </Space>
  </Space>
);
